/**
 * Reusable autoplaying ambient video for atmospheric sections.
 * Always muted, looped, playsInline. Light cream overlay for legibility.
 */
export default function AmbientVideo({
  src,
  poster,
  className = "",
  overlay = "medium",
  rounded = true,
  testId = "ambient-video",
  children,
}) {
  const overlays = {
    none: "",
    light: "bg-[var(--cc-bg)]/30",
    medium: "bg-[var(--cc-bg)]/45",
    strong: "bg-[var(--cc-bg)]/65",
  };
  return (
    <div
      data-testid={testId}
      className={`relative overflow-hidden ${rounded ? "rounded-[28px]" : ""} ${className}`}
    >
      <video
        className="absolute inset-0 w-full h-full object-cover"
        autoPlay
        loop
        muted
        playsInline
        preload="metadata"
        poster={poster}
      >
        <source src={src} type="video/mp4" />
      </video>
      <div className={`absolute inset-0 ${overlays[overlay] || overlays.medium}`} />
      {children && <div className="relative z-10 h-full">{children}</div>}
    </div>
  );
}
